// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isDuplicated = (object: any, index: number, array: any[]) =>
  array.indexOf(object) === index
